export const version = '1.0.6';